import { unlockYourPotentialData } from "./UnlockYourPotentialData";
import styles from "./UnlockYourPotential.module.css";
import Image from "next/image";

type UnlockYourPotentialDataType = {
  title: string;
  description: string;
};

type LogoType = { url: string; alt?: string } | { src: string; alt: string };

type AccreditedDataType = {
  title: string;
  logos: LogoType[];
};

interface UnlockYourPotentialProps {
  Data?: UnlockYourPotentialDataType;
  AccreditedData?: AccreditedDataType;
}

const UnlockYourPotential: React.FC<UnlockYourPotentialProps> = ({
  Data,
  AccreditedData,
}) => {
  const {
    title = unlockYourPotentialData.title,
    description = unlockYourPotentialData.description,
  } = Data || {};

  const {
    title: accreditationTitle = unlockYourPotentialData.accreditationTitle,
    logos = unlockYourPotentialData.logos,
  } = AccreditedData || {};

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className={styles.accreditation}>
        <h2>{accreditationTitle}</h2>
        <div className={styles.logos}>
          {logos.map((logo, index) => (
            <Image
              key={index}
              src={"url" in logo ? logo.url : logo.src}
              alt={logo.alt || ""}
              title={logo.alt || ""}
              width={200}
              height={100}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default UnlockYourPotential;
